import React, { Component } from 'react';
import { Text, Platform, TouchableHighlight, Image, ImageBackground, StyleSheet, View } from 'react-native';

export default class EonnButton extends Component {
  
  static defaultProps = {
    loading: false,
  }

  constructor(props) {
    super(props);
    
    this.styles = StyleSheet.create({
      wrapper: {
        marginTop: 40,
        marginBottom: 40,
        marginLeft: 5,
        marginRight: 5,
        width: 380,
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: '85%',
      },
      buttonBackground: {
        width: '100%',
        borderRadius: 5,
        overflow: 'hidden',
      },
      button: {
        backgroundColor: props.white ? 'white' : 'none',
        borderColor: '#e96556',
        borderWidth: props.white ? 2 : 0,
      },
      textWrapper: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingRight: 30,
        paddingLeft: 30,
        paddingTop: 14,
        paddingBottom: (Platform.OS === 'web') ? 14 : 8,
      },
      textWrapperSmall: {
        paddingTop: 10,
        paddingBottom: (Platform.OS === 'web') ? 10 : 6,
      },
      hover: {
        backgroundColor: props.white ? '#f9f1f1' : '#ed6e60',
      },
      text: {
        color: props.white ? '#e96556' : '#ffffff',
        fontSize: 23,
        fontFamily: 'nunito',
        lineHeight: 24,
        padding: 0,
        flexDirection : "row",
        justifyContent : "flex-end",
        textTransform: 'uppercase',
        fontWeight: 'bold',
        letterSpacing: 0.03,
      },
      textSmall: {
        fontSize: 15,
        lineHeight: 18,
      }
    });

    this.state = {
      hover: false,
      style: [this.styles.textWrapper, props.small ? this.styles.textWrapperSmall : null],
    };

  }

  render() {
    
    return (
      <View style={[this.styles.wrapper,this.props.style]}>
        <ImageBackground
          style={this.styles.buttonBackground}
          source={require('../assets/images/buttonbg.png')}
        >
            <TouchableHighlight
              disabled={this.props.loading}
              style={this.styles.button}
              underlayColor={ this.props.white ? '#eeeff3' :'rgba(0,20,106,0.05)'}
              onPress={() => {
                var requirementsMet = true;
                //console.log(this.props.required?.());
                this.props.required?.().forEach(field => {
                  if (!field){
                    this.props.showRequired();

                    requirementsMet = false;
                    console.log("requirements not met");
                  }
                });
                if (requirementsMet){
                  if (this.props.screen){
                    this.props.replace
                    ? this.props.navigationProps.navigate(this.props.screen,this.props.param)
                    : this.props.navigationProps.replace(this.props.screen,this.props.param);
                  } else {
                    this.props.onPress();
                  }
                }}}
              onMouseEnter={() =>
                this.setState({
                  hover: true,
                  style: [this.styles.textWrapper, this.props.small ? this.styles.textWrapperSmall : null, this.styles.hover],
                })}
              onMouseLeave={() =>
                this.setState({
                  hover: false,
                  style: [this.styles.textWrapper, this.props.small ? this.styles.textWrapperSmall : null],
                })}
            >
                <View style={[this.state.style, {flexDirection: 'row', alignItems: 'center'}]}>
                    <View style={{alignItems: 'center'}}>
                      {this.props.lines
                        ? this.props.lines.map((item,index) =>
                          <Text key={index} style={[
                              this.styles.text,
                              this.props.small ? this.styles.textSmall : null,
                              {fontSize: item.size ? item.size : (this.props.small ? 15 : 20)}
                            ]}>
                            {item.text ? item.text : null}</Text>
                          )
                        : <Text style={[this.styles.text, this.props.small ? this.styles.textSmall : null]}>{this.props.children}</Text>
                      }
                    </View>
                    {this.props.loading && (
                      <Image 
                        source={require('../assets/images/loading.gif')} 
                        style={{
                          width: this.props.small ? 16 : 20,
                          height: this.props.small ? 16 : 20,
                          marginLeft: 10,
                        }}
                        resizeMode="contain"
                      />
                    )}
                </View>
            </TouchableHighlight>
        </ImageBackground>
      </View>
    );
  }
}

